// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__1cqvt","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__1G5HW"};